import { apiPost } from '../lib/api'

export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS'

// result of this action is not processed by any reducer
export const sendMessage = body => ({ getState, fetch }) => ({
  type: 'SEND_MESSAGE',
  payload: apiPost({
    fetch,
    endpoint: 'messages',
    getState,
    body,
  }),
})



// WEBPACK FOOTER //
// ./src/common/messages/actions.js